// extracted by mini-css-extract-plugin
export default {"container":"empty-placeholder_container__RN6XT"};